// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu_menu__KgwV9","nav":"Menu_nav__yW5No"};